import { createContext, useState } from 'react';

export interface NotificationContextType {
    isShowNotification: boolean;
    setIsShowNotification: React.Dispatch<React.SetStateAction<boolean>>;
}
// eslint-disable-next-line react-refresh/only-export-components
export const NotificationContext = createContext<NotificationContextType>({
    isShowNotification: false,
    setIsShowNotification: () => { },
});

export const NotificationProvider: React.FC<{
    children: React.ReactNode;
}> = ({ children }) => {
    const [isShowNotification, setIsShowNotification] = useState<boolean>(false);
    return (
        <NotificationContext.Provider
            value={{ isShowNotification, setIsShowNotification }}
        >
            {children}
        </NotificationContext.Provider>
    );
};
